import { httpClient2 } from '../../infrastructure/admi-client/http-client';

export interface VmStateDto {
    state: string;
    lastStartedUser: string | null;
}

export const admiPvSolVmService = {
    async startVirtualMachine() {
        const response = await httpClient2.post('/v1/pv-sol-vm', {});

        return response.data;
    },

    async stopVirtualMachine() {
        const response = await httpClient2.delete('/v1/pv-sol-vm');

        return response.data;
    },

    async getVirtualMachineState() {
        const response = await httpClient2.get<VmStateDto>('/v1/pv-sol-vm');

        return response.data;
    },

    buildVmConnectRdpLink() {
        // Static file served by Cloudflare Pages from public/data/
        return '/data/pv-sol-vm.rdp';
    },
};
